



class PaiduserDatalist {
  constructor(user_Id, userNum, user_number, profileImage, name, gender, joining_Date, date_of_birth, age, mobile_Number, e_Mail, documents, is_Paid, type, email_Status, mobileNumber_Status,
    documentStatus, documentPath, line_1, line_2, isPaidUser, isPaid, lookUpId, role, mobileNumber, themeColour, themeColourText, themeColourNumber
  ) {
    this.user_Id = user_Id;
    this.userNum = userNum;
    this.user_number = user_number;
    this.profileImage = profileImage;
    this.name = name;
    this.gender = gender;
    this.joining_Date = joining_Date;
    this.date_of_birth = date_of_birth;
    this.age = age;
    this.mobile_Number = mobile_Number;
    this.e_Mail = e_Mail;
    this.documents = documents;
    this.is_Paid = is_Paid;
    this.type = type;
    this.email_Status = email_Status;
    this.mobileNumber_Status = mobileNumber_Status;
    this.documentStatus = documentStatus;
    this.documentPath = documentPath;
    this.line_1 = line_1;
    this.line_2 = line_2;
    this.isPaidUser = isPaidUser;
    this.isPaid = isPaid;
    this.lookUpId = lookUpId;
    this.role = role;
    this.mobileNumber = mobileNumber;
    this.themeColour = themeColour;
    this.themeColourText = themeColourText;
    this.themeColourNumber = themeColourNumber;


  }
  static fromJson(json) {
    return new PaiduserDatalist(
      json.user_Id,
      json.userNum,
      json.user_number,
      json.profileImage,
      json.name,
      json.gender,
      json.joining_Date,
      json.date_of_birth,
      json.age,
      json.mobile_Number,
      json.e_Mail,
      json.documents,
      json.is_Paid,
      json.type,
      json.email_Status,
      json.mobileNumber_Status,

      json.documentStatus,
      json.documentPath,
      json.line_1,
      json.line_2,
      json.isPaidUser,
      json.isPaid,
      json.lookUpId,
      json.role,
      json.mobileNumber,
      json.themeColour,
      json.themeColourText,
      json.themeColourNumber


    );
  }
}
export default PaiduserDatalist;